import React, { useEffect, useState } from 'react';

const SimpleHeader = ({ behind, higher, children }) => {
  const [mask1, setMask1] = useState(false);
  const [mask2, setMask2] = useState(true);
  const [mask3, setMask3] = useState(true);

  // useEffect(() => {
  //   let int1 = null;
  //   let int2 = null;
  //   let int3 = null;

  //   int1 = setInterval(() => {
  //     setMask1(mask => !mask);
  //   }, 2000);

  //   const timeout1 = setTimeout(() => {
  //     int2 = setInterval(() => {
  //       setMask2(mask => !mask);
  //     }, 1000);
  //   }, 800);

  //   const timeout2 = setTimeout(() => {
  //     int3 = setInterval(() => {
  //       setMask3(mask => !mask);
  //     }, 1500);
  //   }, 1500);

  //   return () => {
  //     clearTimeout(timeout1);
  //     clearTimeout(timeout2);
  //     clearInterval(int1);
  //     clearInterval(int2);
  //     clearInterval(int3);
  //   };
  // }, []);

  return (
    <div
      className={`
        main-header 
        ${behind ? 'main-header--behind' : ''} 
        ${higher ? 'higher' : ''}`}
    >
      {children}
      <div className="bg-trans">
        <div className={`trans1 ${mask1 ? 'mask' : ''}`}>
          <div className="point v1" />
          <div className="point v2" />
          <div className="point v3" />
          <div className="point v4" />
          <div className="point sm s1" />
          <div className="point sm s2" />
          <div className="point sm s3" />
          <div className="point sm s4" />
        </div>
        <div className={`trans2 ${mask2 ? 'mask' : ''}`}>
          <div className="point v1" />
          <div className="point v2" />
          <div className="point v3" />
          <div className="point v4" />
          <div className="point sm s1" />
          <div className="point sm s2" />
          <div className="point sm s3" />
          <div className="point sm s4" />
        </div>
        <div className={`trans3 ${mask3 ? 'mask' : ''}`}>
          <div className="point v1" />
          <div className="point v2" />
          <div className="point v3" />
          <div className="point v4" />
          <div className="point sm s1" />
          <div className="point sm s2" />
          <div className="point sm s3" />
          <div className="point sm s4" />
        </div>
      </div>
    </div>
  );
};

export default SimpleHeader;
